import { render } from "./PhoneSettingView.vue?vue&type=template&id=287a2488"
import script from "./PhoneSettingView.vue?vue&type=script&lang=js"
export * from "./PhoneSettingView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__